import React from 'react';
import TestimonialSlider from '../components/TestimonialSlider'; 
import Header from '../components/header'; 
import Footer from '../components/footer'; 

const About = () => {
  return (
    <div>
      <Header />
      
<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/9.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">About us</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	  <div className="section padding-top-bottom over-hide">
        <div className="container">
            <div className="row">
                <div className="col-md-7 align-self-center">
                    <div className="row justify-content-center">
                        <div className="col-10">
                            <div className="subtitle text-center mb-4">Best Hotel in Rourkela</div>
                            <h2 className="text-justify">Welcome to Hotel Pahadi Convention</h2>
                            <p className="text-justify mt-5">Experience comfort, elegance, and impeccable hospitality at Hotel Pahadi Convention, one of the best hotels in Rourkela for premium stays, events, and conventions. Our well-appointed guest rooms offer modern amenities including air-conditioning, 24/7 room service, and hot & cold water for a relaxing stay. Enjoy delicious multi-cuisine dishes at our in-house restaurant, crafted to delight every palate. For corporate meetings, social gatherings, and grand events, our fully equipped conference and banquet halls provide the perfect venue with advanced facilities and seamless arrangements. Whether you're visiting for business, celebrations, or leisure, Hotel Pahadi Convention promises a luxurious and memorable hospitality experience in Rourkela.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-5 mt-4 mt-md-0">
                    <div className="img-wrap">
                        <img src="img/rooms.png" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    </div>
 
	<div className="section padding-top-bottom over-hide">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8 align-self-center">
                    <div className="subtitle with-line text-center mb-4">Experience Exceptional Services</div>
                    <h3 className="text-center padding-bottom-small"> At Our Hotel In Rourkela</h3>
                </div>
                <div className="section clearfix"></div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/icons/booking.png" alt=""/>
                        <h5 className="mt-1">No Booking fees</h5>
                        <p className="mt-3 text-justify">Enjoy complete transparency with our no booking fees policy, ensuring you pay only for your stay without any hidden or extra charges.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/icons/best-price.png" alt=""/>
                        <h5 className="mt-1">Best rate guarantee</h5>
                        <p className="mt-3  text-justify">Benefit from our best rate guarantee, offering you the most competitive prices and unmatched value whenever you book directly with us.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/icons/reservation.png" alt="" />
                        <h5 className="mt-1">Reservation 24/7</h5>
                        <p className="mt-3  text-justify">Enjoy round-the-clock reservation support, allowing you to book your stay anytime with ease, convenience, and reliable assistance whenever you need it.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/icons/wifi.png" alt=""/>
                        <h5 className="mt-1">High Speed WIFI</h5>
                        <p className="mt-3  text-justify">Stay connected with our high-speed Wi-Fi, offering seamless browsing, smooth streaming, and uninterrupted access throughout your entire stay.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/6.svg" alt=""/>
                        <h5 className="mt-2">Dining</h5>
                        <p className="mt-3  text-justify">Savor a delightful dining experience with freshly prepared dishes, rich flavors, and a welcoming ambiance crafted to satisfy every palate.</p>
                       
                    </div>
                </div>
                  <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center cll">
                        <img src="img/icons/no-smoking.png" alt=""/>
                        <h5 className="mt-2">No Smoking</h5>
                        <p className="mt-3  text-justify">Savor a delightful dining experience with freshly prepared dishes, rich flavors, and a welcoming ambiance crafted to satisfy every palate.</p>
                       
                    </div>
                </div>
               
                 
            </div>
        </div>
    </div>
	
	  <div className="section padding-top over-hide background-grey">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8 align-self-center">
                    <div className="subtitle with-line text-center mb-4">Testimonials</div>
                    <h3 className="text-center padding-bottom-small">What Customer say</h3>
                </div>
            </div>
        </div>
    </div>

	<div className="section padding-top-bottom-big over-hide">
		<div className="parallax" style={{ backgroundImage: `url('/img/5.jpg')` }}></div>
		 <TestimonialSlider />
	</div>
	
	<div className="section background-dark over-hide">
        <div className="container-fluid py-4">
            <div className="row">
                <div className="col-sm-6 col-lg-4">
                    <a href="/rooms">
                        <div className="img-wrap services-wrap">
                            <img src="img/ser1.png" alt=""/>
                            <div className="services-text-over">Rooms</div>
                        </div>
                    </a>
                </div>
                <div className="col-sm-6 col-lg-4 pt-4 pt-sm-0">
                    <a href="/dinein">
                        <div className="img-wrap services-wrap">
                            <img src="img/ser2.png" alt=""/>
                            <div className="services-text-over">restaurant</div>
                        </div>
                    </a>
                </div>
                
                <div className="col-sm-6 col-lg-4 pt-4 pt-lg-0">
                    <a href="/banquet">
                        <div className="img-wrap services-wrap">
                            <img src="img/ser4.png" alt=""/>
                            <div className="services-text-over">Banquet</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
<br />
        <Footer />
    </div>
  )
}

export default About;